import { render } from "./WriteEmail.vue?vue&type=template&id=a72027aa&scoped=true"
import script from "./WriteEmail.vue?vue&type=script&lang=js"
export * from "./WriteEmail.vue?vue&type=script&lang=js"

import "./WriteEmail.vue?vue&type=style&index=0&id=a72027aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72027aa"]])

export default __exports__